import { SET_ERRORS_LIST } from "./types";

export const setErrorsList = (msg, err_key = "", timeout = 2000) => (
// export const setErrorsList = (msg, err_key = "", timeout = 5000) => (
  dispatch
) => {
  dispatch({
    type: SET_ERRORS_LIST,
    payload: { [err_key]: msg },
  });
};
